// This file was automatically generated from appchart.dialog.selectPrescribingPhysician.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.selectPrescribingPhysician');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.selectPrescribingPhysician.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form id="select-prescribing-physician-form" class="el8DialogContainer"><select name="user" class="w100">');
  if (opt_data.users) {
    el8.template.appchart.dialog.selectPrescribingPhysician.usersList(opt_data, output);
  }
  output.append('</select></form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.selectPrescribingPhysician.usersList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var uList2821 = opt_data.users;
  var uListLen2821 = uList2821.length;
  for (var uIndex2821 = 0; uIndex2821 < uListLen2821; uIndex2821++) {
    var uData2821 = uList2821[uIndex2821];
    output.append('<option value="', soy.$$escapeHtml(uData2821.id), '">', soy.$$escapeHtml(uData2821.name), '</option>');
  }
  if (!opt_sb) return output.toString();
};
